import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslationService} from '../services/translation.service';

@Pipe({
    name: 'translate',
    pure: false
})

export class TranslationPipe implements PipeTransform {

    constructor(
        private _translationService: TranslationService, private _domSanitizer: DomSanitizer
    ) {
    }

    public transform(translationKey: string): string {
        if (!translationKey || translationKey.trim() === '')
            return '';

        const value: string = this._translationService.getTranslation(
            translationKey
        );
        return value;
    }

}
